import styled from 'styled-components';

export const FilterSelectGrid = styled.div`
  display: grid;
  grid-template-columns: 0.7fr 2fr 1fr 2fr;
  row-gap: 1em;
  align-items: center;
  label {
    margin-right: 1rem;
  }
  label:nth-child(4) {
    margin-left: 1rem;
  }
  label:nth-child(8) {
    margin-left: 1rem;
  }
  .date-range-picker {
    width: 100%;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 740px;
  padding: 0 30px 20px 30px;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  align-self: stretch;
`;

export const SectionHeader = styled.div`
  display: grid;
  grid-template-columns: 0.7fr 2fr 3fr;
  align-items: center;
  button {
    justify-self: end;
  }
`;

export const GroupByRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  align-self: stretch;
  .MuiFormControl-root {
    margin-bottom: 0;
  }
`;
